import './LoadingPage.css'


export default function LoadingPage(){
    return <div class="loadingPage">
        <div class="drop"></div>
        <div class="wave"></div>
        <p>LOADING</p>
    </div>
}